var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_vm._v("Ajouter un compte")]),_c('v-divider',{staticClass:"mb-6"}),_c('div',[_c('UserForm',{attrs:{"from-manager":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }